<template>
  <div ref="labelsContainer" class="absolute -top-3 left-4 flex space-x-1">
    <div v-if="isCharterFlight" ref="charterLabelRef">
      <CharterLabel />
    </div>
    <FeatureLabel
      v-for="(label, idx) in visibleLabels"
      :key="idx"
      :label="label"
    >
      {{ label.text }}
    </FeatureLabel>
  </div>
</template>

<script setup lang="ts">
  import { ref, watch, toRef } from 'vue';
  import { CharterLabel } from 'freedom-shared';

  import FeatureLabel from './FeatureLabel.vue';
  import { useLabelsOverflow } from './lib';
  import type { Label } from './types';

  const props = defineProps<{
    labels: Label[];
    isCharterFlight?: boolean;
  }>();

  const labelsContainer = ref<HTMLElement | null>(null);
  const charterLabelRef = ref<HTMLElement | null>(null);

  const { visibleLabels, checkLabelsOverflow } = useLabelsOverflow(
    labelsContainer,
    props.labels,
    toRef(props, 'isCharterFlight'),
    charterLabelRef,
  );

  watch(
    () => props.labels,
    async newLabels => {
      await checkLabelsOverflow(newLabels);
    },
    { immediate: true },
  );
</script>
